<div dir="rtl" class="justify-content-center align-items-center bg-gredient position-relative">
  <div class="row m-0 justify-content-center justify-content-center">
    <div class="col-12 col-lg-8 text-center">
      <h2 class="text-center main-text">طلب دعوة حضور</h2>
      <img src="../../../../assets/images/windorex-logo.png" class="align-middle m-auto" alt="logo"/>
    </div>
    <div class="col-lg-8 col-12 d-flex align-items-center">
      <mat-card class="cardWithShadow w-100 m-t-md m-b-md">
        <mat-card-content class="p-32">
          <!--<div class="text-center">
            <img src="../../../assets/images/PolywinLogo.png" class="align-middle m-2" alt="logo" />
          </div>-->

          <form class="m-t-30" [formGroup]="form" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-12 col-lg-2">
                <!-- Title -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.title' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="title" placeholder="{{ 'windoRex.selectTitle' | translate }}">
                      <mat-option *ngFor="let title of titles" [value]="title.value">
                        {{ title.text }}
                      </mat-option>
                    </mat-select>
                    @if (f['title'].touched && f['title'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['title'].errors && f['title'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.selectTitle' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <!-- Full Name -->
                <div class="inputTxt">
                  <mat-label
                    class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.fullName' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="fullName" placeholder="{{ 'windoRex.fullName' | translate }}"/>
                    @if (f['fullName'].touched && f['fullName'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['fullName'].errors && f['fullName'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.enterFullName' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <!-- State -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.state' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="selectedState" (valueChange)="changeState($event)"
                                placeholder="{{ 'windoRex.state' | translate }}">
                      <mat-option *ngFor="let state of governrates" [value]="state">
                        {{ state.state }}
                      </mat-option>
                    </mat-select>
                    @if (f['state'].touched && f['state'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['state'].errors && f['state'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.selectState' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <!-- City -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.city' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="city" placeholder="{{ 'windoRex.city' | translate }}">
                      <mat-option *ngFor="let city of Citites" [value]="city">
                        {{ city }}
                      </mat-option>
                    </mat-select>
                    @if (f['city'].touched && f['city'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['city'].errors && f['city'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.selectCity' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Address -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.address' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="address" placeholder="{{ 'windoRex.address' | translate }}"/>
                    @if (f['address'].touched && f['address'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['address'].errors && f['address'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.enterAddress' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-3">
                <!-- Type -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">
                    {{ 'windoRex.workshopType' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="workshopType"
                                placeholder="{{ 'windoRex.selectWorkshopType' | translate }}">
                      <mat-option *ngFor="let type of workshopTypes" [value]="type.value">
                        {{ type.text }}
                      </mat-option>
                    </mat-select>
                    @if (f['workshopType'].touched && f['workshopType'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['workshopType'].errors && f['workshopType'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.selectWorkshopType' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>

                </div>
              </div>
              <div class="col-12 col-md-6" *ngIf="ShowWorkshopFields">
                <!-- Workshop -->
                <div class="inputTxt">
                  <mat-label
                    class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ WorkshopLabel }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <button mat-button [matMenuTriggerFor]="menu" matPrefix>
                      <span>
                        {{ WorkshopClassLabel }}/
                        <i-tabler name="caret-down-filled" class="icon-10"></i-tabler>
                      </span>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item *ngFor="let classification of workshopClassifications"
                              (click)="changeClassification(classification)">
                        <span>{{ classification.text }}</span>
                      </button>
                    </mat-menu>
                    <input matInput formControlName="workshop" placeholder="{{ WorkshopLabel }}"/>
                    @if (f['workshop'].touched && f['workshop'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['workshop'].errors && f['workshop'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.enterWorkshop' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-3" *ngIf="ShowWorkshopFields"></div>
              <div class="col-12 col-md-3">
                <!-- Phone -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ 'windoRex.phone' | translate }}
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="phone" placeholder="{{ 'windoRex.phone' | translate }}"/>
                    @if (f['phone'].touched && f['phone'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['phone'].errors && f['phone'].errors['required']) {
                          <div class="text-error">{{ 'windoRex.enterPhone' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <!-- Email -->
                <div class="inputTxt">
                  <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">
                    {{ 'windoRex.email' | translate }} ({{ 'windoRex.optional' | translate }})
                  </mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="email" type="email"
                           placeholder="{{ 'windoRex.email' | translate }}"/>
                    @if (f['email'].touched && f['email'].invalid) {
                      <mat-hint class="m-b-16 error-msg">
                        @if (f['email'].errors && f['email'].errors['email']) {
                          <div class="text-error">{{ 'windoRex.invalidEmail' | translate }}</div>
                        }
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Message -->
            <div class="inputTxt">
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">
                {{ 'windoRex.message' | translate }} ({{ 'windoRex.optional' | translate }})
              </mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <textarea matInput formControlName="message"
                          placeholder="{{ 'windoRex.writeAmessage' | translate }}"></textarea>
              </mat-form-field>
            </div>

            <div *ngIf="formErrors.length>0">
              <div *ngFor="let error of formErrors">
                <p class="validation-error">{{ error }}</p>
              </div>
            </div>

            <button color="primary" class="w-100 btnLogin" type="submit">
              {{ 'windoRex.submit' | translate }}
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-8 col-12 logo-footer">
      <img src="../../../../assets/images/polywin-Logo.png" alt="logo"/>
      <img src="../../../../assets/images/KEMETWIN-Logo.png" class="m-l-auto" alt="logo"/>
    </div>
  </div>
</div>

<ngx-spinner type="ball-elastic-dots"></ngx-spinner>
